module.exports = __webpack_public_path__ + "static/img/wap.f254061.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/en/初中/wap.svg
// module id = dy1N
// module chunks = 16